import { Button, Flex, Skeleton } from '@driftt/dds'
import { faPlus } from '@driftt/dds.icons/regular/faPlus'
import React, { useMemo } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'

import { PersonaForm } from 'components/AIConfiguration/LeadQualification/PersonaCard/types'
import { PropertyDefinition } from 'types/contacts'

import AttributeRow from './AttributeRow'

interface Props {
  disabled: boolean
  isLoading: boolean
  contactAttributes: PropertyDefinition[]
}

const Attributes = ({ disabled, isLoading, contactAttributes }: Props) => {
  const { control, watch } = useFormContext<PersonaForm>()

  const attributesFormValue = watch('attributes')
  const attributeNameOptions = useMemo(() => {
    const formattedContactAttributes =
      contactAttributes.map(({ name, displayName, type }) => ({
        label: displayName,
        value: name,
        type,
      })) || []

    attributesFormValue.forEach(({ name }) => {
      if (
        typeof name === 'string' &&
        !formattedContactAttributes.find(({ value }) => value === name)
      ) {
        formattedContactAttributes.push(name)
      }
    })
    return formattedContactAttributes
  }, [contactAttributes, attributesFormValue])

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'attributes',
  })

  const handleAddAttribute = () => {
    append({
      name: null,
      operator: null,
      value: '',
    })
  }

  return (
    <>
      <Flex gap={1} direction="column" css={{ marginBottom: '$2' }} fullWidth>
        {isLoading ? (
          <>
            <Skeleton isLoading height={25} />
            <Skeleton isLoading height={25} />
            <Skeleton isLoading height={25} />
          </>
        ) : (
          <>
            {fields.map((field, idx, arr) => (
              <AttributeRow
                key={field.id}
                idx={idx}
                canDelete={arr.length > 1}
                disabled={disabled}
                remove={remove}
                attributeNameOptions={attributeNameOptions}
              />
            ))}
          </>
        )}
      </Flex>

      <Button
        variant="secondary"
        onClick={handleAddAttribute}
        disabled={disabled || isLoading}
        size="small"
      >
        <Button.Icon icon={faPlus} />
        Add another attribute
      </Button>
    </>
  )
}

export default Attributes
